var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('h2',{staticClass:"loading"},[_vm._v("Loading...")]):_vm._e(),(_vm.mapHTML)?_c('div',{staticClass:"hl-web-component map-layout",domProps:{"innerHTML":_vm._s(_vm.mapHTML)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }